const translations = {
  "en": {
    "Contact Us": "Contact Us"
  },
  "zh-tw": {
    "Contact Us": "聯絡我們"
  }
};

export default translations;
